import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Element, scroller } from 'react-scroll';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import Axios from 'axios';
import CONFIG from '../../../config';
import '../../Pricing/pricing.css';
import '../../Pricing/shine.css';
import '../../Dashboard/styles/dashboard.css';
import { regionalCourses } from '../../../Data/regionalCourses';
import { regionalsLangObject } from '../../../Data/regionalsArray';
import { regionalCourseTypes } from '../../../Data/regionalCourseTypes';
// import regionalPricing from './regionalPricing.json';
import { handlePremiumPackage } from '../../../utils/pricing';
import { getCountryCode } from '../../../utils/countryCode';
import {
  pricingPlan,
  setCurrency,
  updateStudentModalStatus,
  totalAmountToPay,
  saveSubscriptionType,
  updateUserLocationDetails,
  updateCheckoutPromoCode,
  updateOfferStatus,
  updateOfferName,
} from './../../../Actions';
import { Container, Title, CourseImg, CourseDivInfoContainer, InfoTag, PromoWrapper } from './styles';
// import { PrimeOffer } from '../../ui/SnackBar';
import { DboardSelect } from '../../Dashboard/styles';
import SiteButton from '../../ui/Button/siteButtons';
import { ButtonLoader } from '../../ui/Loader';
import {
  CoursesLayoutWrapper,
  CourseGroupSelectWrapper,
  NavWrapper,
  NavHead,
  NavBtnsWrapper,
  NavBtn,
  NavTitle,
  NavCheckbox,
  CoursesResultWrapper,
  CoursesContainer,
  NewCourseDiv,
  CourseTitle,
  CourseBottomDiv,
  CoursePriceDiv,
  CourseListPrice,
  CourseOfferPrice,
  CourseBuyButtonWrapper,
  CoursePricingBar,
} from '../../PartnerPlus/CourseSection/styles';
import { FaCaretDown, FaArrowRight } from 'react-icons/fa';

class Courses extends Component {
  state = {
    showContent: false,
    btnLoading: false,
    packagePriceLoading: false,
    btnLoadingIndex: 0,
    sectionHeight: document.getElementById('courses') && document.getElementById('courses').clientHeight / 3,
    activeGroup: this.props.courseCategory || 'animation',
    priceDetails: {},
    oneYearPlan: {},
    localPricing: true, // default local pricing
    packageTitle: '',
    packagePricingLink: '',
    packageWorth: '',
    courseCount: '',
    coursesPlanDetails: [],
    plansApiLoading: true,
    plansApiNoResponse: false,
  };

  async componentDidMount() {
    const { activeGroup } = this.state;
    const { language, coursesLanguage } = this.props;
    localStorage.setItem('pr_cd', false);
    localStorage.setItem('offer', false);
    this.props.updateCheckoutPromoCode(false);
    this.props.updateOfferStatus(false);
    this.props.updateOfferName('');

    if (language === 'tamil') {
      let currentPackage = regionalsLangObject[language]['packages'].filter((ele) => ele.groupName === activeGroup);
      if (currentPackage && currentPackage.length !== 0) {
        this.setState({
          packageTitle: currentPackage[0].groupTitle,
          packagePricingLink: currentPackage[0].pricingLink,
          courseCount: currentPackage[0].courseCount,
          packageWorth: currentPackage[0].packageWorth,
        });
        let result = await this.pricingApiCall(null, null, currentPackage[0].pathID);
      }
    } else {
      let currentPackage = regionalsLangObject[language]['packages'].filter((ele) => ele.groupName === activeGroup);
      if (currentPackage) {
        this.setState({
          packageTitle: coursesLanguage,
          packagePricingLink: `/regionals-${language}-pricing`,
          courseCount: currentPackage[0].courseCount,
          packageWorth: currentPackage[0].packageWorth,
        });
        let result = await this.pricingApiCall('regional', language);
      }
    }

    let plansResult = await this.coursePlansApiCall();

    this.setState({
      showContent: false,
      sectionHeight: document.getElementById('courses') && document.getElementById('courses').clientHeight / 3,
    });
  }

  pricingApiCall = async (type, Urllanguage, pathID) => {
    const { userLocationDetails, updateUserLocationDetails } = this.props;
    const { localPricing } = this.state;

    let countryCode = await getCountryCode(userLocationDetails, updateUserLocationDetails);
    this.setState({ countryCode: countryCode });

    let result;

    if (type && Urllanguage) {
      result = await Axios.get(CONFIG.apiURL + `/pricing?countryCode=${countryCode}&type=${type}&lang=${Urllanguage}`);
    } else {
      result = await Axios.get(CONFIG.apiURL + `/pricing?countryCode=${countryCode}&type=comboPackage&pathID=${pathID}`);
    }

    if (result && result.data) {
      this.setState({ priceDetails: result.data });

      let oneYearGlobal;
      let oneYearLocal;

      if (result.data.showToggle === true && localPricing === true) {
        if (Object.keys(result.data.local).length !== 0) {
          oneYearLocal = result.data.local.oneYear;
        }
        this.setState({ oneYearPlan: oneYearLocal, packagePriceLoading: false });
      } else {
        if (Object.keys(result.data.global).length !== 0) {
          oneYearGlobal = result.data.global.oneYear;
        }
        this.setState({ oneYearPlan: oneYearGlobal, packagePriceLoading: false });
      }
    }
  };

  handleCourseGroup = async (courseGroup) => {
    const { language, coursesLanguage } = this.props;

    if (this.state.activeGroup !== courseGroup) {
      this.setState({ activeGroup: courseGroup, packagePriceLoading: true });

      if (language === 'tamil') {
        let currentPackage = regionalsLangObject[language]['packages'].filter((ele) => ele.groupName === courseGroup);
        if (currentPackage && currentPackage.length !== 0) {
          this.setState({
            packageTitle: currentPackage[0].groupTitle,
            packagePricingLink: currentPackage[0].pricingLink,
            courseCount: currentPackage[0].courseCount,
            packageWorth: currentPackage[0].packageWorth,
          });
          let result = await this.pricingApiCall(null, null, currentPackage[0].pathID);
        }
      } else {
        let currentPackage = regionalsLangObject[language]['packages'].filter((ele) => ele.groupName === courseGroup);
        if (currentPackage && currentPackage.length !== 0) {
          this.setState({
            packageTitle: coursesLanguage,
            packagePricingLink: `/regionals-${language}-pricing`,
            courseCount: currentPackage[0].courseCount,
            packageWorth: currentPackage[0].packageWorth,
          });
          let result = await this.pricingApiCall('regional', language);
        }
      }
    }
  };

  scrollTo(name) {
    scroller.scrollTo(name, {
      duration: 600,
      delay: 0,
      smooth: true,
      offset: -90,
    });
  }

  handleMoreCourses = () => {
    this.setState({
      showContent: !this.state.showContent,
      sectionHeight: this.state.sectionHeight,
    });
    if (this.state.showContent) this.scrollTo('courses');
  };

  handleBuyNowDetails = async (planID, index, freeCourse, id, pathID) => {
    this.setState({ btnLoading: true, btnLoadingIndex: index });

    // if (freeCourse === true) {
    //   if (id !== '') {
    //     window.location.href = `/courses/${id}?p_id=${window.btoa(planID)}`;
    //   }
    // }

    const { country, saveSubscriptionType, totalAmountToPay, pricingPlan, history } = this.props;
    let result = await Axios.get(CONFIG.apiURL + `/pricing?countryCode=${country}&type=yearly&pathID=${pathID}`);

    if (result.data) {
      let priceValue = result.data.local && Object.keys(result.data.local).length !== 0 && result.data.local;
      handlePremiumPackage({
        pricing: priceValue,
        pricingPlan,
        origin: 'REGIONAL_LANDING',
        history,
        totalAmountToPay,
        subscriptionType: 'yearly',
        saveSubscriptionType,
      });
      this.setState({ btnLoading: false });
    }
  };

  handleCourseNavigation = (language, courseID, upComing) => {
    if (!upComing) {
      this.props.history.push(`/regionals-${language}-courses/${courseID}/?lb_content=${window.location.hostname + window.location.pathname}&lb_cta=lp-course-crd`);
    }
  };

  // individual courses planList api
  coursePlansApiCall = async () => {
    let { language, country } = this.props;
    let payload = { country: country, type: 'individualPricing', planType: language };
    this.setState({ plansApiLoading: true });

    try {
      let plansResponse = await Axios.post(`${CONFIG.logsDomain}/lbindividualpricing`, payload);
      if (plansResponse && plansResponse.data && plansResponse.data.length !== 0) {
        this.setState({ coursesPlanDetails: plansResponse.data, plansApiLoading: false, plansApiNoResponse: false });
      } else {
        this.setState({ plansApiLoading: false, plansApiNoResponse: true });
      }
    } catch (error) {
      this.setState({ plansApiLoading: false, plansApiNoResponse: true });
    }
  };

  // individual courses pricing api
  handleCoursePricingApi = async (plan, index) => {
    const { history, pricingPlan, totalAmountToPay, saveSubscriptionType } = this.props;

    // for button loading
    this.setState({ btnLoading: true, btnLoadingIndex: index });

    this.props.updateCheckoutPromoCode(false);
    this.props.updateOfferStatus(true);
    this.props.updateOfferName('');

    // checkout navigation
    handlePremiumPackage({
      pricing: plan,
      pricingPlan,
      origin: 'REGIONAL_LANDING',
      history,
      totalAmountToPay,
      subscriptionType: 'yearly',
      saveSubscriptionType,
      utm_src: 'rgnl-crs-sec',
    });
    this.setState({ btnLoading: false });
  };

  _renderPricingDetails = (language, courseID, index, freeCourse, upComing) => {
    const { coursesPlanDetails, plansApiLoading, plansApiNoResponse, btnLoading, btnLoadingIndex } = this.state;
    let coursePriceDetail = {};

    if (coursesPlanDetails && coursesPlanDetails.length !== 0) {
      coursePriceDetail = coursesPlanDetails.find((ele) => ele.courseID === courseID);
    }

    if (plansApiLoading) {
      return (
        <CourseBottomDiv onClick={() => this.handleCourseNavigation(language, courseID, upComing)}>
          <Skeleton className="no-line-height" height={'32px'} width={'60px'} />
          <Skeleton className="no-line-height ml-2" height={'34px'} width={'85px'} style={{ borderRadius: '25px' }} />
        </CourseBottomDiv>
      );
    } else if (plansApiNoResponse) {
      return <Fragment>{freeCourse === true ? <span className="dboard-tag-shine dboard-green-tag no-line-height fs-12 text-light weight-600">Free</span> : null}</Fragment>;
    } else if (coursePriceDetail && Object.keys(coursePriceDetail).length !== 0) {
      return (
        <Fragment>
          {coursePriceDetail.offerPercentage ? (
            <span className="dboard-tag-shine dboard-blue-tag no-line-height fs-12 text-light weight-600">{coursePriceDetail.offerPercentage}% Off</span>
          ) : null}
          <CourseBottomDiv>
            <CoursePriceDiv>
              <CourseListPrice>
                <span className="headingFont">{coursePriceDetail.currencySymbol}</span>
                {coursePriceDetail.listPrice}
              </CourseListPrice>
              <CourseOfferPrice>
                <span className="headingFont">{coursePriceDetail.currencySymbol}</span>
                {coursePriceDetail.offerPrice}
              </CourseOfferPrice>
            </CoursePriceDiv>
            <CourseBuyButtonWrapper>
              <SiteButton
                roundedBtn
                onClick={(e) => {
                  this.handleCoursePricingApi(coursePriceDetail, index);
                }}
              >
                Buy now
                {btnLoading && btnLoadingIndex === index && (
                  <ButtonLoader styleGif={{ height: '15px', width: '15px' }} style={{ height: '15px', marginLeft: '4px', marginRight: '0px' }} />
                )}
              </SiteButton>
            </CourseBuyButtonWrapper>
          </CourseBottomDiv>
        </Fragment>
      );
    } else if (freeCourse === true) {
      return (
        <CourseBottomDiv isFree onClick={() => this.handleCourseNavigation(language, courseID, upComing)}>
          <InfoTag isFree style={{ marginTop: 'unset' }}>
            Free course
          </InfoTag>
        </CourseBottomDiv>
      );
    } else if (upComing === true) {
      return (
        <InfoTag upcoming style={{ marginTop: '10px' }}>
          Upcoming
        </InfoTag>
      );
    }
  };

  render() {
    const {
      showContent,
      sectionHeight,
      btnLoading,
      btnLoadingIndex,
      packagePriceLoading,
      activeGroup,
      priceDetails,
      oneYearPlan,
      packageTitle,
      packagePricingLink,
      packageWorth,
      courseCount,
      coursesPlanDetails,
      plansApiNoResponse,
    } = this.state;
    const {
      history,
      language,
      country,
      name,
      userID,
      trialStatus,
      paymentStatus,
      pricingPlan,
      totalAmountToPay,
      saveSubscriptionType,
      coursesLanguage,
      courseCategory,
    } = this.props;
    const cloudFront = CONFIG.cloudFront;
    let showIndex = showContent ? 12 : 9;
    let renderComboPricing = packagePriceLoading === false && priceDetails && oneYearPlan && Object.keys(oneYearPlan).length !== 0;

    return (
      <Element name="courses" id="courses">
        <Container>
          <Title>
            <span style={{ textTransform: 'capitalize' }}>{language}</span> Courses ({coursesLanguage})
          </Title>

          <div className="d-flex align-items-center flex-column flex-sm-row justify-content-sm-center d-md-none pt-1 pb-3">
            <CourseGroupSelectWrapper>
              <DboardSelect onChange={(e) => this.handleCourseGroup(e.target.value)} value={activeGroup} style={{ padding: '4px 30px 4px 10px' }}>
                {regionalCourseTypes[language] &&
                  Object.keys(regionalCourseTypes[language]) &&
                  Object.keys(regionalCourseTypes[language]).map((groupName) => (
                    <Fragment key={groupName}>
                      {regionalCourses[language][groupName] ? <option value={groupName}>{regionalCourseTypes[language][groupName]}</option> : null}
                    </Fragment>
                  ))}
              </DboardSelect>
              <FaCaretDown className="select-drop-icon siteTxtColor" />
            </CourseGroupSelectWrapper>
          </div>

          <CoursesLayoutWrapper>
            <NavWrapper>
              <NavHead>Browse Courses</NavHead>
              <NavBtnsWrapper>
                {regionalCourseTypes[language] &&
                  Object.keys(regionalCourseTypes[language]) &&
                  Object.keys(regionalCourseTypes[language]).map((groupName) => (
                    <Fragment key={groupName}>
                      {regionalCourses[language][groupName] ? (
                        <NavBtn htmlFor={`regionals-${groupName}`} navActive={activeGroup === groupName} onClick={() => this.handleCourseGroup(groupName)}>
                          <NavTitle navActive={activeGroup === groupName} style={{ textTransform: 'none' }}>
                            {regionalCourseTypes[language][groupName]}
                          </NavTitle>
                          <NavCheckbox id={`regionals-${groupName}`} type="checkbox" checked={activeGroup === groupName} />
                        </NavBtn>
                      ) : null}
                    </Fragment>
                  ))}
              </NavBtnsWrapper>
            </NavWrapper>

            <CoursesResultWrapper>
              <CoursesContainer>
                {regionalCourses[language][activeGroup] &&
                  regionalCourses[language][activeGroup].length !== 0 &&
                  regionalCourses[language][activeGroup].map(
                    ({ id, courseID, pathID, title, cardImg, upComing, newStatus, indianPrice, planID, offer, freeCourse, isPricing }, index) => (
                      <NewCourseDiv key={id} country={country}>
                        <CourseImg
                          src={cloudFront + cardImg}
                          style={{ cursor: !upComing && 'pointer' }}
                          onClick={() => this.handleCourseNavigation(language, courseID, upComing)}
                        />

                        <CourseDivInfoContainer>
                          <CourseTitle style={{ cursor: !upComing && 'pointer', paddingBottom: 'unset' }} onClick={() => this.handleCourseNavigation(language, courseID, upComing)}>
                            {title} in <span className="text-inheritance">{coursesLanguage}</span>
                          </CourseTitle>

                          {this._renderPricingDetails(language, courseID, index, freeCourse, upComing)}

                          {/* {(offer || freeCourse) && ( <div style={{margin: '0 auto', paddingTop: '3px'}}> <PrimeOffer isNoMargin={true} noMarginTop={true} /></div>)} */}

                          {/*<div className="d-flex align-items-center justify-content-between" style={{ flexWrap: 'wrap', rowGap: '2px' }}>
                            {freeCourse ? (
                              <InfoTag isFree>Free course</InfoTag>
                            ) : upComing ? (
                              <InfoTag upComing>Upcoming course</InfoTag>
                            ) : !isPricing || (isPricing && country !== 'IN') ? (
                              <InfoTag>Included with Prime Membership</InfoTag>
                            ) : null}
        
                            {isPricing && indianPrice && country === 'IN' && (
                              <Fragment>
                                <div className="d-flex align-items-center">
                                  <CourseListPrice>
                                    <span className="headingFont">₹</span>
                                    {indianPrice.listPrice}
                                  </CourseListPrice>
                                  <CourseOfferPrice>
                                    <span className="headingFont">₹</span>
                                    {indianPrice.offerPrice}
                                  </CourseOfferPrice>
                                </div>
                                <CourseBuyButtonWrapper>
                                  <SiteButton
                                    roundedBtn
                                    onClick={(e) => {
                                      this.handleBuyNowDetails(planID, index, freeCourse, id, pathID);
                                    }}
                                  >
                                    Buy now
                                    {btnLoading && btnLoadingIndex === index && (
                                      <ButtonLoader
                                        style={{
                                          height: '15px',
                                          marginLeft: '4px',
                                          marginRight: '0px',
                                        }}
                                        styleGif={{ height: '15px', width: '15px' }}
                                      />
                                    )}
                                  </SiteButton>
                                </CourseBuyButtonWrapper>
                              </Fragment>
                            )}
                          </div>*/}

                          {/*{isPricing && indianPrice && country === 'IN' && (
                          <PromoWrapper>
                            <p className="fs-14 text-white text-center">
                              Get <span className="pricingYellowTxt weight-600">10%</span> off - use code <span className="pricingYellowTxt weight-600">WELCOME10</span>
                            </p>
                          </PromoWrapper>
                          )}*/}
                        </CourseDivInfoContainer>
                      </NewCourseDiv>
                    )
                  )}
              </CoursesContainer>

              <CoursePricingBar
                onClick={() => {
                  if (renderComboPricing) window.location.href = packagePricingLink;
                }}
              >
                {renderComboPricing ? (
                  <p className="text-inheritance">
                    Get unlimited access to{' '}
                    {language === 'tamil' ? (
                      <span className="text-nowrap">
                        <span className="headingFont weight-500">
                          all {courseCount} {packageTitle}
                        </span>{' '}
                        <span className="headingFont weight-600">{coursesLanguage}</span>
                      </span>
                    ) : (
                      <span className="headingFont weight-600">
                        all {courseCount} premium {packageTitle}
                      </span>
                    )}{' '}
                    courses{' '}
                    {country === 'IN' && language && language !== 'bengali' && language !== 'kannada' && (
                      <span className="d-inline-block">
                        (worth <span className="headingFont weight-500">{packageWorth}</span>)
                      </span>
                    )}{' '}
                    for{' '}
                    <span className="d-inline-block">
                      <span className="headingFont weight-600">
                        {oneYearPlan.currencySymbol}
                        {oneYearPlan.offerPrice}
                      </span>{' '}
                      / year.
                    </span>{' '}
                    <span className="text-nowrap weight-600 ghostLink no-line-height ml-1">Buy now ➜</span>
                  </p>
                ) : (
                  <div className="text-center" style={{ boxShadow: '0px 0px 1px var(--greyShadowColor)' }}>
                    <SkeletonTheme color={'var(--greyBgLight)'} highlightColor={'var(--greyShadowColor)'}>
                      <Skeleton className="d-md-none no-line-height" height={'40px'} />

                      <Skeleton className="d-none d-md-block no-line-height" width={'450px'} height={'30px'} />
                    </SkeletonTheme>
                  </div>
                )}
              </CoursePricingBar>
            </CoursesResultWrapper>
          </CoursesLayoutWrapper>
        </Container>
      </Element>
    );
  }
}

const mapStateToProps = ({ User, Pricing }) => ({
  userID: User.username,
  name: User.name,
  email: User.email,
  userLocationDetails: User.locationDetails,
  country: User.locationDetails && User.locationDetails.country,
  trialStatus: User.trialStatus,
  paymentStatus: User.paymentStatus,
  currency: Pricing.currency,
  countryCode: Pricing.countryCode,
  currencySymbol: Pricing.currencySymbol,
});

const mapDispatchToProps = (dispatch) => ({
  pricingPlan: (selectedCourses) => dispatch(pricingPlan(selectedCourses)),
  totalAmountToPay: (amountToPay) => dispatch(totalAmountToPay(amountToPay)),
  setCurrency: (currency, symbol, country) => dispatch(setCurrency(currency, symbol, country)),
  updateStudentModalStatus: (optionModalStatus, mailModalStatus) => dispatch(updateStudentModalStatus(optionModalStatus, mailModalStatus)),
  updateUserLocationDetails: (locationDetails) => dispatch(updateUserLocationDetails(locationDetails)),
  saveSubscriptionType: (subscriptionType) => dispatch(saveSubscriptionType(subscriptionType)),
  updateCheckoutPromoCode: (promoCode) => dispatch(updateCheckoutPromoCode(promoCode)),
  updateOfferStatus: (status) => dispatch(updateOfferStatus(status)),
  updateOfferName: (value) => dispatch(updateOfferName(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Courses);
